const headerItems = {
  home: {
    title: "Home",
    link: "/",
  },
  movie: {
    title: "movies",
    link: "/movie",
  },
  tv: {
    title: "TV Series",
    link: "/tv",
  },
};

export const headerNav = Object.values(headerItems);
